<div class="fixed  "
     [ngClass]="{
        'custom-top' : positionY === 'top',
        'custom-bottom' : positionY === 'bottom',
        'custom-right' : positionX === 'right',
        'custom-left' : positionX === 'left',
        'custom-center' : positionX === 'center'
     }"
     style="max-width: 370px; z-index: 9999;"
>
    <div class="relative bg-red-50 border border-gray-200 rounded-md h-full px-4 py-4 shadow animation-slide-open
                flex flex-row items-center justify-between
    "
        style="max-height: 15%;width: 355px;"
    >   
        <div class="flex items-center gap-1">
            <!---- Icon PSS ----->
            <div class="w-14 h-full">
                <img src="icons/tools/PSS/PSS Sticker-04.png"  />  
            </div>
            <!---- Content ----->
            <div class="flex flex-col justify-center items-start">
                <p class="w-full font-bold text-red-600">{{ text }}</p>
                <p class="w-full text-sm text-gray-400 break-words" style="max-width: 100%; height: auto;">
                    {{ detail }}
                </p>
            </div>
        </div>
        <!---- Close Icon -->
        <div class="w-5 h-full" (click)="onClickClose()" *ngIf="isButton">
            <img src="icons/tools/close.png" />
        </div>       
        <!---- Background Left Content--->
        <div class="absolute left-0 top-0 h-full py-2" *ngIf="!loading">
            <div class="bg-red-400 rounded-r-md h-full w-2"></div>
        </div>
        <!-- แถบโหลด (Progress bar) -->
        <div class="absolute bottom-0 left-0 h-1 bg-red-500 rounded-b-md"
            *ngIf="loading"
            [style.width.%]="progress">
        </div>
    </div>
</div>